import * as React from 'react';

import styled, { css, useTheme } from 'styled-components';

export interface SeparatorLineProps {
  className?: string;
  lineDot?: boolean;
  noMargin?: boolean;
}

export const SeparatorLine: React.FC<SeparatorLineProps> = (props) => {
  const theme = useTheme();
  return props.lineDot ? (
    <svg
      className={props.className}
      width="100%"
      height="1px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="100%"
        height="1px"
        fill="none"
        stroke={theme.colors.border}
        strokeWidth="4"
        strokeDasharray="2, 25"
        strokeDashoffset="0"
        strokeLinecap="square"
      />
    </svg>
  ) : (
    <span className={props.className} />
  );
};

export default styled(SeparatorLine)`
  margin: 10px 0;
  border-top: 1px dotted ${({ theme }) => theme.colors.border};
  height: 1px;
  width: 100%;
  display: block;

  @media ${({ theme }) => theme.device.laptopS} {
    margin: 20px 0;
  }

  ${(props) =>
    props.lineDot
      ? css`
          border: none;
        `
      : null}

  ${(props) =>
    props.noMargin
      ? css`
          margin: 0;
          @media ${({ theme }) => theme.device.laptopS} {
            margin: 0;
          }
        `
      : null}
`;
